import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../styles';
import ContactModal from './ContactModal';

const styles = css`
  position: fixed;
  left: 0;
  bottom: 0;
  height: 60px;
  width: 100%;
  background-color: ${colors.color4};
  z-index: 10;
  @media (min-width: 992px) {
    display: none;
  }
  .OSCMobileTag_inner {
    display: flex;
  }

  .OSCMobileTag_image {
    width: 20%;
    height: 60px;
    text-align: center;
    background-color: #666666;
    img {
      width: auto;
      height: 100%;
    }
  }
  .OSCMobileTag_content {
    width: 100%;
    display: flex;
  }
  .OSCMobileTag_headlineWrapper {
    height: 60px;
    background-color: ${colors.color2Dark};
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
  }
  .OSCMobileTag_headline {
    color: white;
    font-weight: 700;
    font-size: 18px;
    font-family: ${typography.Serif};
    line-height:1;
  }
  .OSCMobileTag_links {
    height: 60px;
    width: 55%;
    color: white;
    background-color: ${colors.color2Light};
    list-style: none;
    padding: 0;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
    li {
      text-align: center;
      font-size: 11px;
      line-height: 1;
      font-weight: 700;
      a, span {
        color: #FFFFFF;
      }
    }
    img {
      height: 18px;
      width: auto;
      margin: 0 0 4px 0;
    }
  }
`;

function OSCTagMobile({ builder }) {
  return (
    <div className={styles} >
      <div className="OSCMobileTag_wrapper">
        <div className="OSCMobileTag_inner">
          <div className="OSCMobileTag_content">
            <div className="OSCMobileTag_headlineWrapper">
              <div className="OSCMobileTag_headline">Ask {builder.name}!</div>
            </div>
            <ul className="OSCMobileTag_links">
              <li><a href={`tel:${get(builder, 'telephone', '').replace(/[^0-9]/g, '')}`}><img src="/images/icon-phone-white.svg" alt="phone icon" /><br />Call</a></li>
              <li><ContactModal builder={builder}><img src="/images/icon-email-white.svg" alt="email icon" /><br />Email</ContactModal></li>
              {
                get(builder, 'sms_telephone_number') &&
                  <li><a href={`sms:${get(builder, 'sms_telephone_number', '').replace(/[^0-9]/g, '')}`}><img src="/images/icon-text-white.svg" alt="text icon" /><br />Text</a></li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

OSCTagMobile.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(OSCTagMobile);



// WEBPACK FOOTER //
// ./src/components/OSCTagMobile.js